export var Color;
(function (Color) {
    Color["White"] = "hsl(0, 0%, 100%)";
    Color["Black"] = "hsl(0, 0%, 4%)";
    Color["Light"] = "hsl(0, 0%, 96%)";
    Color["Dark"] = "hsl(0, 0%, 21%)";
    Color["Primary"] = "hsl(171, 100%, 41%)";
    Color["Link"] = "hsl(217, 71%, 53%)";
    Color["Info"] = "hsl(204, 86%, 53%)";
    Color["Success"] = "hsl(141, 71%, 48%)";
    Color["Warning"] = "hsl(48, 100%, 67%)";
    Color["Danger"] = "hsl(348, 100%, 61%)";
})(Color || (Color = {}));
